import React from 'react'

const Text = () => {
    return (
        <div className="bg-white w-100 rounded-xl shadow-sm px-4 py-3">
            <p>
                Ankara Dijital Reklam, günümüzün rekabetçi iş dünyasında işletmelerin başarıya ulaşmaları için vazgeçilmez bir araç haline gelmiştir.
                Hızla büyüyen iş dünyasıyla Ankara, dijital reklamcılık hizmetlerine olan talebin arttığı
                <strong className="text-warning text-decoration-underline"> bir şehir olarak öne çıkmaktadır</strong>.
                Markaların hedef kitlelerine etkili bir şekilde ulaşabilmesi için dijital reklamcılık, pazarlama stratejilerinin merkezinde yer almaktadır.
                Bu noktada, Ankara’nın önde gelen dijital reklam ajanslarından biri olan Nano Medya karşımıza çıkmaktadır.
                Nano Medya, işletmelere özel çözümler sunarak marka bilinirliği ve satışları artırma konusunda önemli katkılarda bulunmaktadır.
                Nano Medya’nın sunduğu stratejik dijital çözümler, işletmelerin dijital dünyada rekabet avantajı elde etmelerine olanak tanımaktadır.
            </p>
            <br />
            <p>
                Ankara Dijital Reklam, günümüzün rekabetçi
                <strong className="text-warning text-decoration-underline"> iş dünyasında</strong> işletmelerin başarıya ulaşmaları için vazgeçilmez bir araç haline gelmiştir.
                Hızla büyüyen iş dünyasıyla Ankara, dijital reklamcılık hizmetlerine olan talebin arttığı bir şehir olarak öne çıkmaktadır.
                Markaların hedef kitlelerine etkili bir şekilde ulaşabilmesi için dijital reklamcılık, pazarlama stratejilerinin merkezinde yer almaktadır.
                Bu noktada, Ankara’nın önde gelen dijital reklam ajanslarından biri olan Nano Medya karşımıza çıkmaktadır.
                Nano Medya, işletmelere özel çözümler sunarak marka bilinirliği ve satışları artırma konusunda önemli katkılarda bulunmaktadır.
                Nano Medya’nın sunduğu stratejik dijital çözümler, işletmelerin dijital dünyada rekabet avantajı elde etmelerine olanak tanımaktadır.
            </p>
            <br />
            <p>
                <strong className="text-warning text-decoration-underline">Ankara Dijital Reklam</strong>, günümüzün rekabetçi iş dünyasında işletmelerin başarıya ulaşmaları için vazgeçilmez bir araç haline gelmiştir.
                <strong className="text-warning text-decoration-underline">Hızla büyüyen iş dünyasıyla</strong> Ankara, dijital reklamcılık hizmetlerine olan talebin arttığı bir şehir olarak öne çıkmaktadır.
                Markaların hedef kitlelerine etkili bir şekilde ulaşabilmesi için dijital reklamcılık, pazarlama stratejilerinin merkezinde yer almaktadır.
                Bu noktada, Ankara’nın önde gelen dijital reklam ajanslarından biri olan Nano Medya karşımıza çıkmaktadır.
                Nano Medya, işletmelere özel çözümler sunarak marka bilinirliği ve satışları artırma konusunda önemli katkılarda bulunmaktadır.
                Nano Medya’nın sunduğu stratejik dijital çözümler, işletmelerin dijital dünyada rekabet avantajı elde etmelerine olanak tanımaktadır.
            </p>
        </div>

    )
}

export default Text
